import { render, staticRenderFns } from "./button-call.vue?vue&type=template&id=604e2cd2"
import script from "./button-call.vue?vue&type=script&lang=js"
export * from "./button-call.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports